import { render, staticRenderFns } from "./RelationLink.vue?vue&type=template&id=55645b70"
import script from "./RelationLink.vue?vue&type=script&lang=js"
export * from "./RelationLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports